module.exports = "<div class=\"animations\">\n\t<transition :name=\"effect\">\n\t\t<slot v-if=\"show\"></slot>\n\t</transition>\n</div>\n"